// Cases & Challenges cards: the right column shows the first subtitle of the
// page plus the first paragraph that follows it. Ghost has no helper to pull
// that out of a page's HTML, so the whole `{{content}}` is rendered and then
// trimmed down to those two blocks. Anything else is removed from the DOM.
(function () {
    const previews = document.querySelectorAll('.case-card-preview');
    if (!previews.length) return;

    previews.forEach(function (preview) {
        const children = Array.prototype.slice.call(preview.children);
        const heading = preview.querySelector('h2, h3');
        const keep = [];

        if (heading) {
            keep.push(heading);
            for (let i = children.indexOf(heading) + 1; i < children.length; i++) {
                if (children[i].tagName === 'P') {
                    keep.push(children[i]);
                    break;
                }
            }
        } else {
            // No subtitle in the page: fall back to its first paragraph.
            const paragraph = preview.querySelector('p');
            if (paragraph) keep.push(paragraph);
        }

        Array.prototype.slice.call(preview.childNodes).forEach(function (node) {
            if (keep.indexOf(node) === -1) {
                node.remove();
            }
        });
    });
})();
